module.exports = __webpack_public_path__ + "img/app-store-7cab3e2.png";